// import React, { useContext, useEffect, useRef, useState } from "react";
// import { useImmer } from "use-immer";
// import "./LiveStatusClock.scss";
// import { Tooltip } from "@mui/material";
// import { end } from "@popperjs/core";
// import { APP_BASE_URL_SOCKET, TELEMETRY_SOCKET_URL, tsToDateFormatter } from "../../../Common/EndPoints";
// import { ActiveAlarmsData } from "../../Alarms/ActiveAlarms";
// import toast from "react-hot-toast";
// import { getLocalStorage } from "../../../Utils/storage-utils";
// import useLogout from "../../Login/useLogout";

// function getLastUpdatedAt(ts) {
//   if (!ts) {
//     return "OFFLINE";
//   }
//   const currentTs = Date.now();
//   const elapsed = currentTs - ts;
//   const seconds = Math.floor(elapsed / 1000);
//   const minutes = Math.floor(seconds / 60);
//   const hours = Math.floor(minutes / 60);
//   if (hours >= 1) {
//     return `Last updated ${hours} ${hours === 1 ? "hr" : "hrs"} ago`;
//   } else if (minutes >= 1) {
//     return `Last updated ${minutes} ${minutes === 1 ? "min" : "mins"} ago`;
//   } else {
//     if (seconds <= 0) {
//       return `Updating Continuously`;
//     }
//     return `Last updated ${seconds} ${seconds === 1 ? "sec" : "secs"} ago`;
//   }
// }

// const initialLiveStatus = {
//   isLive: true,
//   time: "hh:mm:ss",
//   lastUpdatedTime: null,
//   tooltipMessage: "",
// };
// function hasInternetConnection() {
//   if (navigator.onLine) {
//     return true;
//   } else {
//     return false;
//   }
// }
// let packetTimeOffset = 300000; //5 minuts
// function LiveStatusClock() {
//   const { setServerIsLive } = useContext(ActiveAlarmsData);
//   let liveStatusWebSocket = useRef(null);
//   const { handleLogout } = useLogout;
//   let lastUpdatedTs = useRef(null);
//   let isLive = useRef(false);
//   let userId = localStorage.getItem("userId");
//   const [tooltip, setTooltip] = useState(false);
//   const [tooltipMsg, setTooltipMsg] = useState("OFFLINE");
//   const [liveTime, setLiveTime] = useState("hh:mm:ss");
//   const handleClose = () => {
//     setTooltip(false);
//   };
//   console.log("web event - liverefstate", isLive.current);

//   const handleOpen = () => {
//     // if (liveClock.isLive) {
//     setTooltip(true);
//     // }
//   };

//   useEffect(() => {
//     let liveClock = setInterval(time, 1000);
//     return () => clearInterval(liveClock);
//   }, []);

//   useEffect(() => {
//     getLiveStatus();
//     return () => window.liveStatusWebSocket?.close();
//   }, []);

//   function getLiveStatus() {
//     window.liveStatusWebSocket?.close();
//     // const url = `${APP_BASE_URL_SOCKET}/${userId}/live`;

//     let url = `${APP_BASE_URL_SOCKET}/${userId}/live`;
//     const secret_key = getLocalStorage("id_key") ?? null;

//     if (secret_key) {
//       url = `${url}/key=${secret_key}1111`;
//     } else {
//       toast.error("App will be logged out to fetch latest updates");
//       setTimeout(() => {
//         handleLogout();
//       }, 1500);
//     }
//     window.liveStatusWebSocket = new WebSocket(url);
//     window.liveStatusWebSocket.addEventListener("open", (event, a, b) => {
//       console.log("web event - open", event);
//       isLive.current = true;
//       setServerIsLive(true);
//       // setLiveClock((prev) => {
//       //     prev.isLive = true;
//       // });
//     });
//     window.liveStatusWebSocket.onmessage = (res) => {
//       let webPacket = JSON.parse(res.data);

//       if (webPacket.lastReceviedPacketTs) {
//         let offset = new Date().getTime() - webPacket.lastReceviedPacketTs;
//         lastUpdatedTs.current = webPacket.lastReceviedPacketTs;
//         if (offset < packetTimeOffset) {
//           if (!isLive.current) {
//             isLive.current = true;
//             setServerIsLive(true);
//           }
//         } else {
//           isLive.current = false;
//           setServerIsLive(false);
//         }
//       } else {
//         isLive.current = false;
//         setServerIsLive(false);
//       }
//     };
//     window.liveStatusWebSocket.onclose = (error) => {

//       if (error?.code !== 1008) {
//         isLive.current = false;
//         setServerIsLive(false);
//         toast.error(error?.reason || "Unable to connect live clock websocket");
//       }
//     };
//   }
//   // console.log("dsahfjkhsd out", isLive.current);
//   function time() {
//     let d = new Date();
//     let s = d.getSeconds();
//     let m = d.getMinutes();
//     let h = d.getHours();
//     if (isLive.current && hasInternetConnection()) {
//       let hours = h < 10 ? "0" + h : h;
//       let minutes = m < 10 ? "0" + m : m;
//       let sec = s < 10 ? "0" + s : s;

//       setLiveTime(hours + ":" + minutes + ":" + sec);
//     }
//     if (!hasInternetConnection()) {
//       isLive.current = false;
//       setServerIsLive(false);
//     } else {
//       if (!isLive.current) {
//         isLive.current = true;
//         setServerIsLive(true);
//       }
//     }

//     setTooltipMsg(getLastUpdatedAt(lastUpdatedTs?.current));
//   }

//   return (
//     <Tooltip
//       open={tooltip}
//       onClose={handleClose}
//       sx={{ backgroundColor: "red" }}
//       onOpen={handleOpen}
//       placement="bottom"
//       title={<div className="liveClockTooltip">{tooltipMsg}</div>}
//       disableInteractive
//     >
//       <div className={`liveStatusClock ${!isLive.current ? "isOffline" : ""}`}>
//         <div className={`blinkIcon ${isLive.current ? "blinkAnimation" : ""} `}></div>
//         <div className="clockText">{liveTime}</div>
//       </div>
//     </Tooltip>
//   );
// }

// export default LiveStatusClock;

import React, { useContext, useEffect, useRef, useState } from "react";
import { Tooltip } from "@mui/material";
import toast from "react-hot-toast";
import "./LiveStatusClock.scss";
import { APP_BASE_URL_SOCKET } from "../../../Common/EndPoints";
import { ActiveAlarmsData } from "../../Alarms/ActiveAlarms";
import { getLocalStorage } from "../../../Utils/storage-utils";
import useLogout from "../../Login/useLogout";

function getLastUpdatedAt(ts) {
  if (!ts) return "OFFLINE";
  const elapsed = Date.now() - ts;
  const seconds = Math.floor(elapsed / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);

  if (hours >= 1) return `Last updated ${hours} hr${hours > 1 ? "s" : ""} ago`;
  if (minutes >= 1) return `Last updated ${minutes} min${minutes > 1 ? "s" : ""} ago`;
  return seconds <= 0 ? `Updating Continuously` : `Last updated ${seconds} sec${seconds > 1 ? "s" : ""} ago`;
}

function hasInternetConnection() {
  return navigator?.onLine ?? false;
}

const packetTimeOffset = 300000; // 5 minutes

function LiveStatusClock() {
  const { setServerIsLive } = useContext(ActiveAlarmsData);
  const { handleLogout } = useLogout();

  const liveStatusWebSocket = useRef(null);
  const lastUpdatedTs = useRef(null);
  const isLive = useRef(false);
  const userId = localStorage.getItem("userId");

  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [tooltipMsg, setTooltipMsg] = useState("OFFLINE");
  const [liveTime, setLiveTime] = useState("hh:mm:ss");

  const updateTooltip = () => setTooltipMsg(getLastUpdatedAt(lastUpdatedTs.current));

  useEffect(() => {
    const liveClockInterval = setInterval(updateLiveTime, 1000);
    return () => clearInterval(liveClockInterval);
  }, []);

  useEffect(() => {
    connectWebSocket();
    return () => liveStatusWebSocket.current?.close();
  }, []);

  const connectWebSocket = () => {
    liveStatusWebSocket.current?.close();
    let url = `${APP_BASE_URL_SOCKET}/${userId}/live`;
    const secretKey = getLocalStorage("id_key");

    if (secretKey) {
      url = `${url}/key=${secretKey}`;
    } else {
      toast.error("App will be logged out to fetch latest updates");
      setTimeout(handleLogout, 1500);
      return;
    }

    liveStatusWebSocket.current = new WebSocket(url);
    liveStatusWebSocket.current.onopen = () => {
      isLive.current = true;
      setServerIsLive(true);
    };

    liveStatusWebSocket.current.onmessage = (res) => {
      const packet = JSON.parse(res.data);
      const offset = Date.now() - packet.lastReceviedPacketTs;

      if (packet.lastReceviedPacketTs && offset < packetTimeOffset) {
        if (!isLive.current) {
          isLive.current = true;
          setServerIsLive(true);
        }
        lastUpdatedTs.current = packet.lastReceviedPacketTs;
      } else {
        isLive.current = false;
        setServerIsLive(false);
      }
    };

    liveStatusWebSocket.current.onclose = (error) => {
      if (error?.code === 1008) {
        isLive.current = false;
        setServerIsLive(false);
        toast.error(error?.reason || "Unable to connect live clock websocket");
      }
    };
  };

  const updateLiveTime = () => {
    const now = new Date();
    if (isLive.current && hasInternetConnection()) {
      setLiveTime(now.toLocaleTimeString("en-US", { hour12: false }));
    }

    if (!hasInternetConnection()) {
      isLive.current = false;
      setServerIsLive(false);
    }

    updateTooltip();
  };

  return (
    <Tooltip
      open={tooltipOpen}
      onClose={() => setTooltipOpen(false)}
      onOpen={() => setTooltipOpen(true)}
      placement="bottom"
      title={<div className="liveClockTooltip">{tooltipMsg}</div>}
      disableInteractive
    >
      <div className={`liveStatusClock ${!isLive.current ? "isOffline" : ""}`}>
        <div className={`blinkIcon ${isLive.current ? "blinkAnimation" : ""}`}></div>
        <div className="clockText">{liveTime}</div>
      </div>
    </Tooltip>
  );
}

export default LiveStatusClock;
